module.exports = __webpack_public_path__ + "static/media/measuring.f82770d6.svg";